import React from 'react';
import { useSelector } from 'react-redux';
import WorkshopModalSystem from 'a/hub/screens/Season3/components/modals/WorkshopModalSystem';
import { getSeason } from 'a/hub/selectors';
import {
  getIsLogoutModalOpen,
  getIsSessionTimeoutModalOpen,
  getIsMultipleSessionsModalOpen,
} from 'a/hub/selectors/modalSystemSelectors';
import { SEASON } from 'a/hub/data/constants';
import LogoutModal from './LogoutModal';
import SessionTimeoutModal from './SessionTimeoutModal';
import MultipleSessionsOpenModal from './MultipleSessionsOpenModal';

const ModalSystem = () => {
  const season = useSelector(getSeason);
  const isLogoutModalOpen = useSelector(getIsLogoutModalOpen);
  const isSessionTimeoutModalOpen = useSelector(getIsSessionTimeoutModalOpen);
  const isMultipleSessionsModalOpen = useSelector(getIsMultipleSessionsModalOpen);
  return (
    <div className="app-modal-system">
      {season === SEASON.GRADE_4_5 && <WorkshopModalSystem />}
      {isSessionTimeoutModalOpen && <SessionTimeoutModal />}
      {isLogoutModalOpen && <LogoutModal />}
      {isMultipleSessionsModalOpen && <MultipleSessionsOpenModal />}
    </div>
  );
};

export default ModalSystem;
